export const supportMail = 'kontakt@rota.works';
export const messengerNotificationsLink = 'http://m.me/app.rota';
export const telegramNotificationsLink = 'https://t.me/RotaAppBot';
export const toastTimeout = 3500;
export const autoSaveTimeout = 500;

export const emailValidationRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
